type RumContext = {
	source: string; // File throwing the error
	err: unknown;
};

function extractData(err: Error): string | undefined {
	if ('data' in err && typeof err.data === 'string') {
		return err.data.substring(0, 200);
	}
	return undefined;
}

export const rumLogger = {
	error: (message: string, context: RumContext) => {
		let err: Record<string, unknown> = {};
		if (typeof context.err === 'string') {
			err.message = context.err;
		} else if (context.err instanceof Error) {
			err.message = context.err.message;
			err.name = context.err.name;
			err.stack = context.err.stack ?? '';
			err.data = extractData(context.err);
		} else if (context.err && typeof context.err === 'object') {
			// @ts-expect-error casting
			err = context.err;
		}

		// This could be better structured, but AppD only reports the first param to console.error
		console.error(`[CS] ${context.source}:${message} - ${err?.message}`);
	},
};
